import { render, staticRenderFns } from "./SidebarMenuOption.vue?vue&type=template&id=4f9b7d72"
import script from "./SidebarMenuOption.vue?vue&type=script&lang=js"
export * from "./SidebarMenuOption.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuOption.vue?vue&type=style&index=0&id=4f9b7d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports